import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChart4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chart-4, statistics, graph"} maskId="square-filled-radius-0-stroke-1-IconChart4"><path d="M15.6602 21.001V3.00098H20.9902V21.001H15.6602Z" fill="currentColor"/><path d="M9.33008 8.50098V21.001H14.6601V8.50098H9.33008Z" fill="currentColor"/><path d="M3 14.001V21.001H8.33V14.001H3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChart4;
